import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from '@swimlane/ngx-datatable';
import { Observable } from 'rxjs';
import { App, AppState, History, Tag } from '../../app.models';
import { selectClientId, selectQueryParams } from '../../app.selector';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  $clientId: Observable<string>;
  $history: Observable<History[]>;
  columns: TableColumn[];
  $apps: Observable<App[]>;
  $tags: Observable<Tag[]>;
  public currentLanguageCode: string;

  constructor(
    private store: Store,
    private http: HttpClient,
    private translate: TranslateService
  ) { }
  ngOnInit() {
    this.$clientId = this.store.select(selectClientId);
    this.$history = this.store.select((state: AppState) => state.history)
    this.$apps = this.store.select((state: AppState) => state.apps)
    this.$tags = this.store.select((state: AppState) => state.tags)
    this.currentLanguageCode = this.translate.getBrowserLang();
    this.store.select(selectQueryParams).subscribe()
  }
}
